import React from 'react'
import PropTypes from 'prop-types'

const ReaderNavigationAnalyticsItem = props => {
  let divStyles = props.outerDivStyles
  if (divStyles === undefined) {
    divStyles = ''
  } else {
    divStyles = ' ' + divStyles
  }
  return (
    <div className={'ml-3' + divStyles}>
      {props.numItems !== null && props.numItems > 0 ? (
        <div className="clearfix d-flex justify-content-between">
          <div>{props.title}</div>
          <div data-toggle="tooltip" data-placement="auto">
            <span className="badge">{`${props.numCompletedItems} / ${props.numItems}`}</span>
          </div>
        </div>
      ) : (
        <div />
      )}
    </div>
  )
}

ReaderNavigationAnalyticsItem.propTypes = {
  numItems: PropTypes.number,
  numCompletedItems: PropTypes.number,
  title: PropTypes.string.isRequired,
  outerDivStyles: PropTypes.string,
}

export default ReaderNavigationAnalyticsItem
